import { render, staticRenderFns } from "./ConfirmDialog.vue?vue&type=template&id=0b7c5648&scoped=true&"
import script from "./ConfirmDialog.vue?vue&type=script&lang=js&"
export * from "./ConfirmDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7c5648",
  null
  
)

export default component.exports